<template>
  <div> 
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {         
        changeBg: false
    }
  }
}
</script>

<style>
:root {
  height: 100% !important;
}
body {
  margin: 0;
  /* overflow: hidden; */
  height: 100%;
}
main {
  overflow: hidden !important;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  /* background: linear-gradient(180deg, #1b1e36, 91%, var(--primary)); */
}

.divider {
  display: block;
  height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
}

.divider>div:first-child {
  /* border-right: 1px solid rgba(0,0,0,0.2); */
  min-height: 100vh;
}

@media only screen and (min-width: 768px) {
  .divider {
    display: grid;
    grid-template-columns: 220px auto;
  }
}
</style>